export type ColorTheme = "LIGHT" | "DARK";

export const PROD_HOSTNAME = "on-bible.com";
